import { render, staticRenderFns } from "./VueEditor.vue?vue&type=template&id=4df60c01&scoped=true&"
import script from "./VueEditor.vue?vue&type=script&lang=js&"
export * from "./VueEditor.vue?vue&type=script&lang=js&"
import style0 from "./VueEditor.vue?vue&type=style&index=0&id=4df60c01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df60c01",
  null
  
)

export default component.exports